// ** Icon imports

const navigation = () => {
  return [
    {
      title: "Services",
      path: "/services",
    },
    // {
    //   title: "Order Management",
    //   path: "/order-management",
    // },

    {
      title: "Driver Application",
      path: "/driver-application",
    },
    {
      title: "About Us",
      path: "/about-us",
    },
    {
      title: "Blog",
      path: "/blog",
    },
    {
      title: "Contact Us",
      path: "/contact-us",
    },
  ];
};

export default navigation;
